import { Form } from "antd";
import { Controller } from "react-hook-form";
import Autocomplete from "react-google-autocomplete";
import { InfoIconOutlined } from "../../CustomIcons";

// interface AutoCompleteFieldProps<T extends FieldValues> {
//   fieldName: Path<T>;
//   label?: string;
//   control: Control<T>;
//   defaultValue?: PathValue<T, Path<T>> | undefined;
//   isRequired?: boolean;
//   rules?: object;
//   validate?: "success" | "warning" | "error" | "validating" | undefined;
//   validMessage?: string | React.ReactNode;
//   className?: string;
//   tooltipTitle?: string | React.ReactNode;
//   optionalLabel?: string;
//   hintMessage?: string;
//   warning?: boolean;
//   onPlaceChange: (place) => void;
// }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AutoCompleteField = (props: any) => {
  const {
    fieldName,
    isRequired = false,
    label,
    validMessage,
    className,
    control,
    defaultValue,
    rules,
    tooltipTitle,
    optionalLabel,
    hintMessage,
    warning,
    validate,
    onPlaceChange,
  } = props;

  return (
    <Form.Item
      required={isRequired ?? false}
      label={<div className="label_text">{label}</div>}
      validateStatus={validate}
      help={validMessage}
      className={className}
      tooltip={
        tooltipTitle && {
          title: tooltipTitle,
          placement: "topLeft",
          arrow: false,
          icon: <InfoIconOutlined />,
        }
      }
    >
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field: { onChange, value } }) => {
          return (
            <>
              <Autocomplete
                apiKey="AIzaSyBlsiu2kCn_5Bmd1g43Bk4Vrq7LaoEtbHk"
                onPlaceSelected={(place) => {
                  onChange(place?.formatted_address || ""); // Update react-hook-form
                  onPlaceChange(place);
                }}
                defaultValue={value}
                options={{
                  types: ["address"],
                }}
                className="autoCompleteInput"
                style={{ width: "100%" }}
              />
              {optionalLabel && (
                <div className="optional-label">{optionalLabel}</div>
              )}
              {hintMessage && (
                <div
                  className={
                    warning ? "hint-label warning-label" : "hint-label"
                  }
                >
                  {hintMessage}
                </div>
              )}
            </>
          );
        }}
      />
    </Form.Item>
  );
};
